
    <div class="toast toast-{{toast.type}}" 
      [style.bottom.px]="i*120">
      <h4 class="toast-heading">{{toast.title}}</h4>
      <p>{{toast.body}}</p>
      <a class="close" (click)="remove.emit(i)">&times;</a>
    </div>
  